<template>
  <div class="app-associated-list">
    <list
      ref="list"
      rowKey="documentId"
      :columns="columns"
      :listData="listPageData"
      :showEmpty="showEmpty"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp"
      @click-item="handleClickItem"
    ></list>
    <div
      v-if="btnList.filter(btn => btn.buttonCode === 'ADD').length > 0"
      class="list-add-icon active-style"
      @click="handleCreate"
    >
      <x-svg-icon name="add"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import List from '@/components/list/list.vue'
import apis from '@/api'
import PageButtonTypeMap from './page-button-type'
import {
  mapState
} from 'vuex'

export default {
  components: {
    List
  },
  data() {
    return {
      formId: '',
      listPageConfig: {
        listPage: {
          queryConditions: [],
          queryLists: [],
          tileFormComponent: []
        }
      },
      listPageData: [],
      btnList: [],
      tableConfig: {
        loading: false,
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        }
      },
      cubeScrollOptions: {
        // preventDefault: false,
        pullDownRefresh: {
          txt: '刷新成功'
        },
        pullUpLoad: {
          txt: {
            more: '上滑加载更多',
            noMore: '没有更多数据了'
          }
        },
        scrollbar: false
      },
      mobileKeyWord: '',
      compPayloadKey: this.$route.query.key
    }
  },
  computed: {
    showEmpty: function () {
      return (!this.listPageData || this.listPageData.length === 0) && !this.tableConfig.loading
    },
    ...mapState({
      compPayload: state => state.compRouterModule.compPayload
    }),
    formDetailData() {
      return this.compPayload[this.compPayloadKey].formData
    },
    routeQuery() {
      return this.compPayload[this.compPayloadKey].queryData
    },
    widget() {
      return this.compPayload[this.compPayloadKey].widgetConfig
    },
    columns() {
      return this.listPageConfig.listPage.queryLists.map(item => {
        return this.listPageConfig.listPage.tileFormComponent.find(_item => _item.uuid === item.uuid)
      })
    }
  },
  created() {
    this.formId = this.widget.associationFormId
    this.queryListConfigByFormId(this.formId)
    this.queryListPageButton(this.formId)
  },
  methods: {
    queryListConfigByFormId(formId) {
      this.$nextTick(() => {
        this.tableConfig.loading = true
        this.$loading.show()
      })
      const request = { ...apis.APP_PAGE.QUERY_LIST_PAGE_CONFIG_BY_ID }
      request.params = {
        formId
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            Object.assign(this.listPageConfig, resp.data)
            // 获取表格数据
            this.queryTableData(
              formId,
              this.tableConfig.pagination.currentPage,
              this.tableConfig.pagination.pageSize,
              this.mobileKeyWord
            )
          },
          (err) => {
            this.tableConfig.loading = false
            this.$loading.hide()
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          this.tableConfig.loading = false
          this.$loading.hide()
          console.error(err)
        })
    },
    queryTableData(formId, page, pageSize) {
      // if (
      //   !this.listPageConfig.listPage.queryLists ||
      //   this.listPageConfig.listPage.queryLists.length === 0
      // ) {
      //   this.tableConfig.loading = false
      //   this.listPageData = []
      //   return
      // }
      const inTable = this.routeQuery.inTable
      const request = inTable ? { ...apis.COMPONENT.QUERY_ASSOCIATED_TABLE_FOR_TABLE } : { ...apis.COMPONENT.QUERY_ASSOCIATED_TABLE }
      request.params = {
        originFormId: this.$route.query.formId || this.compPayload[this.compPayloadKey].formId,
        targetFormId: this.widget.associationFormId,
        documentId: this.$route.query.documentId || this.compPayload[this.compPayloadKey].documentId,
        page: page,
        pageSize: pageSize,
        data: this.formDetailData,
        filterConditionGroupList: this.widget.filterConditionGroupList || [],
        assComponentId: this.widget.uuid,
        associationField: {
          originUuid: this.routeQuery.originUuid,
          targetUuid: this.routeQuery.targetUuid
        }
      }
      if (inTable) {
        request.params.associationField.tableUuid = this.routeQuery.tableUUID
        request.params.associationField.originValue = this.routeQuery.originValue
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.tableConfig.loading = false
            this.$loading.hide()
            if (request.params.page === 1) {
              this.listPageData = []
            }
            if (!resp.data.pageQueryResult.result || resp.data.pageQueryResult.result === 0) {
              this.$refs.list.forceUpdate()
            } else {
              this.listPageData = this.listPageData.concat(resp.data.pageQueryResult.result || [])
              this.tableConfig.pagination.currentPage = page
              this.tableConfig.pagination.pageSize = pageSize
              this.tableConfig.pagination.total = resp.data.pageQueryResult.count
              if (this.listPageData.length === resp.data.pageQueryResult.count) {
                this.$refs.list.forceUpdate()
              }
            }
          },
          (err) => {
            this.tableConfig.loading = false
            this.$loading.hide()
            this.$refs.list.forceUpdate()
            console.err(err)
          }
        )
        .asyncErrorCatch((err) => {
          this.tableConfig.loading = false
          this.$loading.hide()
          this.$refs.list.forceUpdate()
          console.err(err)
        })
    },
    queryListPageButton(formId) {
      const request = { ...apis.APP_PAGE.QUERY_LIST_PAGE_BUTTON }
      request.params = {
        formId
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            const btnList = resp.data
            btnList.forEach((btn) => {
              btn.icon = PageButtonTypeMap[btn.buttonCode] && PageButtonTypeMap[btn.buttonCode].icon
              btn.executeFunction =
                PageButtonTypeMap[btn.buttonCode] &&
                PageButtonTypeMap[btn.buttonCode].executeFunction
            })
            this.btnList = btnList
          },
          (error) => {
            console.error(error)
          }
        )
        .asyncErrorCatch((error) => {
          console.error(error)
        })
    },
    onPullingDown(e) {
      this.tableConfig.pagination.currentPage = 1
      this.queryTableData(
        this.formId,
        this.tableConfig.pagination.currentPage,
        this.tableConfig.pagination.pageSize,
        this.mobileKeyWord
      )
    },
    onPullingUp(e) {
      this.queryTableData(
        this.formId,
        this.tableConfig.pagination.currentPage + 1,
        this.tableConfig.pagination.pageSize,
        this.mobileKeyWord
      )
    },
    doSearch(e) {
      this.mobileKeyWord = e
      this.tableConfig.pagination.currentPage = 1
      this.queryTableData(
        this.formId,
        this.tableConfig.pagination.currentPage,
        this.tableConfig.pagination.pageSize,
        this.mobileKeyWord
      )
    },
    handleCreate() {
      this.$router.push({ name: 'form', query: { formId: this.formId, appId: this.$route.query.appId, menuId: this.$route.query.currentMenu || this.$route.query.menuId } })
    },
    handleClickItem(item) {
      this.$router.push({
        name: 'form',
        query: {
          formId: this.formId,
          documentId: item.documentId,
          appId: this.$route.query.appId,
          readOnly: this.compPayload[this.compPayloadKey].operationAuth === 'READ',
          menuId: this.$route.query.currentMenu || this.$route.query.menuId
        }
      })
    }
  }
}
</script>

<style lang="scss">
.app-associated-list {
  width: 100%;
  height: 100%;
  .list {
    width: 100%;
    height: calc(100%);
    overflow: hidden;
    padding: 0.57rem 1.14rem;
    background-color: $--app-body-bgColor;
    box-sizing: border-box;
    .list-card {
      margin-bottom: 0.57rem;
    }
  }
  .list-add-icon {
    width: 2.857rem;
    height: 2.857rem;
    position: absolute;
    right: 1.071rem;
    bottom: 10.36rem;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: $--app-light-color;
    background-color: $--app-primary-color;
    .x-svg-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
